import React from 'react';
import { useSelector } from 'react-redux';

import {
  RealtorRatingBodyLayout as Layout,
  RealtorRatingFieldPeriod as FieldPeriod,
  RealtorRatingFieldRegion as FieldRegion,
  RealtorRatingHeader as Header,
  RealtorRatingTableThead as TableThead,
  RealtorRatingTableTbody as TableTbody,
  RealtorRatingTableTbodySkeleton as TableTbodySkeleton,
  RealtorRatingTableTbodyNotFound as TableTbodyNotFound,
} from '../../components/RealtorRating';
import {
  getRealtorRatingPeriodFieldOptions,
  getRealtorRatingRegionFieldOptions,
  useRealtorRatingFilter,
  useRealtorRatingSortOrdering,
} from '../../utils';
import { selectRegionsNew } from '../../selectors/geo/regionsNew';
import { selectRealtorRatingList } from '../../selectors/realtorRatingList';
import { ERequestStatus } from '../../types/requestStatus';
import { REALTOR_RATING_DEFAULT_PERIOD_VALUE } from '../../constants';

/**
 * Контейнер листинга рейтинга риелторов
 */
export const RealtorRatingContainer = () => {
  const { sortOrdering, sortOrderingType, setSortOrdering } = useRealtorRatingSortOrdering();
  const { region, setRegion, period, setPeriod } = useRealtorRatingFilter();
  const { items: regionItems } = useSelector(selectRegionsNew);
  const { items: realtorRatingListItems, status: realtorRatingListStatus } = useSelector(selectRealtorRatingList);

  return (
    <Layout
      header={<Header />}
      filterFields={
        <>
          <FieldRegion
            value={region}
            options={getRealtorRatingRegionFieldOptions(regionItems)}
            onChange={setRegion}
            disabled={realtorRatingListStatus === ERequestStatus.Loading}
          />

          <FieldPeriod
            value={period}
            options={getRealtorRatingPeriodFieldOptions()}
            onChange={setPeriod}
            disabled={realtorRatingListStatus === ERequestStatus.Loading}
          />
        </>
      }
      tableRows={
        <>
          <TableThead
            onSort={realtorRatingListStatus !== ERequestStatus.Loading ? setSortOrdering : undefined}
            sortOrdering={sortOrdering}
            sortOrderingType={sortOrderingType}
          />

          {realtorRatingListStatus === ERequestStatus.Loading ? (
            <TableTbodySkeleton />
          ) : realtorRatingListItems.length ? (
            <TableTbody
              items={realtorRatingListItems}
              sortOrdering={sortOrdering}
              sortOrderingType={sortOrderingType}
            />
          ) : (
            <TableTbodyNotFound
              showResetFiltersLink={Boolean(region !== 0 || period !== REALTOR_RATING_DEFAULT_PERIOD_VALUE)}
            />
          )}
        </>
      }
    />
  );
};
